<div class="card" style="display: flex">
	<app-colored-icons [notion]="competence" (event)="updateScore($event)"></app-colored-icons>
	<div (click)="navigateTo()" class="libelle">
		{{ competence.libelle }}
	</div>
</div>
